import { Box } from "@mui/material";
import Fields from "./fields";
import { FormProvider, useForm } from "react-hook-form";
import { TConfiguredAgendaItem } from "../../../../accept-invitation-form/type";

type Props = {
  pe_agenda: TConfiguredAgendaItem
}
function NonSubmitableAgenda({ pe_agenda }: Props) {
  const defaultValues = {}
  const methods = useForm({ defaultValues });
  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(() => { })} noValidate>
        <Box>
          {pe_agenda?.formattedAgenda?.map((agenda, index: number) => (
            <Fields key={agenda.inputId} inputId={agenda.inputId} agendaObj={agenda} index={index} isPreviewOnly isLast={index === pe_agenda.formattedAgenda.length - 1} />
          ))}
        </Box>
      </form>
    </FormProvider>
  );
}

export default NonSubmitableAgenda;


